import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthStatusService {
  readonly checkAuthError = signal<string | null>(null);
}
